import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-error-handler-dialog",
    templateUrl: "./error-handler-dialog.component.html",
    styleUrls: ["./error-handler-dialog.component.scss"],
    standalone: false
})
export class ErrorHandlerDialogComponent {
  id: number;
  message: string;
  status: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ErrorHandlerDialogComponent>,
  ) {
    if (data) {
      this.id = data.id;
      this.message = data.message;
      this.status = data.status;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
